
import React from 'react';
import { UserRoundCheck, Clock, Calendar } from "lucide-react";

interface CoachingInfoProps {
  title?: string;
  description?: string;
  sessionType?: string;
  duration?: string;
  focusAreas?: string[];
}

const CoachingInfo = ({ 
  title = "Book Your ML Coaching Session",
  description = "Get personalized guidance from industry experts to accelerate your machine learning career.",
  sessionType = "Coaching Session",
  duration = "60-Minute Deep Dive Sessions",
  focusAreas = [
    "ML System Design Interviews",
    "Technical Interview Preparation", 
    "Career Guidance",
    "Portfolio Review"
  ]
}: CoachingInfoProps) => {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">{title}</h1>
      <p className="text-muted-foreground">
        {description}
      </p>
      
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <UserRoundCheck className="h-6 w-6 text-primary" />
          <span>1:1 Personalized {sessionType}</span>
        </div>
        <div className="flex items-center gap-4">
          <Clock className="h-6 w-6 text-primary" />
          <span>{duration}</span>
        </div>
        <div className="flex items-center gap-4">
          <Calendar className="h-6 w-6 text-primary" />
          <span>Flexible Scheduling</span>
        </div>
      </div>
      
      <div className="bg-accent/50 p-4 rounded-lg">
        <h3 className="font-semibold mb-2">Session Focus Areas</h3>
        <ul className="list-disc pl-5 text-sm space-y-1">
          {focusAreas.map((area, index) => (
            <li key={index}>{area}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CoachingInfo;
